import type { TranslationKey } from '../../i18n/catalog';

const labels: Record<string, TranslationKey> = {
  not_requested: 'customerStatus.notRequested', new: 'customerStatus.sent', pending: 'customerStatus.sent',
  contacted: 'customerStatus.discussing', confirmed: 'customerStatus.confirmed', closed: 'customerStatus.completed', cancelled: 'customerStatus.cancelled',
};
export function customerStatusKey(status: string): TranslationKey {
  return labels[status] || 'customerStatus.notRequested';
}
